import INSTITUTION_TYPES from './types';
import { type IInstitution, type IMetadata } from 'src/models';

interface State {
	institutions: IInstitution[];
	institution: IInstitution;
	isLoading: boolean;
	isLoadingOne: boolean;
	page: number;
	pageSize: number;
	metadata: IMetadata;
}

const initialState: State = {
	institutions: [],
	institution: {},
	isLoading: false,
	isLoadingOne: false,
	page: 1,
	pageSize: 20,
	metadata: {
		totalPages: 0,
		totalResults: 0,
	},
};

const reducer = (state: State = initialState, action: any) => {
	const { type, payload } = action;
	switch (type) {
		case INSTITUTION_TYPES.GET_ALL: {
			return {
				...state,
				isLoading: true,
				page: payload.page || state.page,
				pageSize: payload.pageSize || state.pageSize,
			};
		}

		case INSTITUTION_TYPES.SET_ALL: {
			return {
				...state,
				isLoading: false,
				institutions: payload.data,
				metadata: payload.metadata ? payload.metadata : state.metadata,
			};
		}

		case INSTITUTION_TYPES.GET_ONE: {
			return {
				...state,
				isLoadingOne: true,
			};
		}

		case INSTITUTION_TYPES.SET_ONE: {
			return {
				...state,
				isLoadingOne: false,
				institution: payload.institution,
			};
		}

		case INSTITUTION_TYPES.INITIAL_STATE: {
			return initialState;
		}

		default:
			return state;
	}
};

export default reducer;
